/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import * as React from 'react';
import { css, jsx } from '@atlaskit/css';
import CommentIcon from '@atlaskit/icon/core/comment';
import { Pressable, type PressableProps, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const pressableStyles = xcss({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    height: '3rem',
    width: '3rem',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'border.radius.circle',
});

const boxStyles = css({
    height: '3rem',
    width: '3rem',
    position: 'absolute',
    borderRadius: token('border.radius.circle', '2002rem'),
    boxShadow: token('elevation.shadow.raised', '0px 4px 4px 0px #00000040'),
    backgroundColor: token('color.background.brand.bold', '#0C66E4'),
    '&:hover': {
        backgroundColor: token('color.background.brand.bold.hovered', '#0055CC'),
    },
});

export const ChatBubbleButton = React.forwardRef((props: PressableProps, ref: React.RefObject<HTMLButtonElement>) => {
    return (
        <div css={boxStyles}>
            <Pressable testId="rovo-service-agent-chat-bubble-button" xcss={pressableStyles} {...props} ref={ref}>
                <CommentIcon label="" color={token('color.text.inverse', '#FFFFFF')} />
            </Pressable>
        </div>
    );
});
